<div class="white-label-design-service">
    <router-outlet></router-outlet>
</div>

<p-toast position="bottom-right" [key]="ToastKeys.httpError" />
